export const FORM_DEBOUNCE_TIME = 1400;
export const FORM_AUTO_COMPLETE_DEBOUNCE_TIME = 300;
export const CANT_LOAD_TOO_FAST = 500;
